import React from 'react';
import TourMenuPicker from '../TourMenuPicker/TourMenuPicker.react';
import Button from '../Button/Button.react';
import {PropTypes} from 'prop-types';
import './TourMenuMobile.less';

function _findGroupById(tourData, groupId) {
    let groups = tourData !== null ? tourData.groups : [];
    return groups.find((group) => group.groupId === groupId);
}

class TourMenuMobile extends React.Component {
    static propTypes = {
        onSelectGroup: PropTypes.func,
        tour: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    };

    constructor(props) {
        super(props);
        this.state = {
            show: false,
        };
    }

    onToggleClick = () => {
        this.setState({
            ...this.state,
            ...{
                show: !this.state.show,
            },
        });
    };

    _onSelectGroup = (id) => {
        if (this.props.onSelectGroup) {
            this.props.onSelectGroup(id);
        }
        this.setState({
            ...this.state,
            ...{
                show: false,
            },
        });
    };

    render() {
        const props = this.props;
        let showClass = this.state.show ? 'open' : '';
        let pickerProps = {
            ...props,
            ...{onSelectGroup: this._onSelectGroup},
        };
        let tourData = props.tour.get('tourData') || null;
        let groupId = props.tour.get('groupId');
        return (
            <div className={'TourMenuMobile'}>
                <Button className={'TourMenuDropdownToggle'} onClick={this.onToggleClick}>
                    <span className={'TourMenuDropdownToggle-label'}>
                        {(_findGroupById(tourData, groupId) || {}).label || ''}
                    </span>
                    <span
                        className={`SVGIcon SVGIcon--12px TourMenuDropdownToggle-icon ${showClass}`}
                    >
                        <svg
                            data-id="SVG_CHEVRON_DOWN__12"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M11 4L6 9 1 4"
                            />
                        </svg>
                    </span>
                </Button>
                <TourMenuPicker {...pickerProps} className={this.state.show ? 'open' : ''} />
            </div>
        );
    }
}

export default TourMenuMobile;
